import SVGIcon from '../SVGIcon/SVGIcon';
import styled from 'styled-components';

export const getLegacyStatusColor = (status: string) => {
  switch (status) {
    case 'PENDING_ACCEPTANCE':
      return '#D4B106';
    case 'PENDING_APPROVAL':
      return '#E56910';
    case 'APPROVAL_DISAPPROVED':
      return '#808289';
    case 'ACCEPTED':
      return '#2998BD';
    case 'CANCELED':
      return '#808289';
    case 'DECLINED':
      return '#E2483C';
    case 'SENT':
      return '#E3B205';
    case 'IN_PROGRESS':
      return '#64B9FF';
    case 'PENDING_DELIVERY':
      return '#1E7AFD';
    case 'DELIVERING':
      return '#1E7AFD';
    case 'DELIVERED':
      return '#43A047';
    default:
      return '#E8EBF2';
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'WAITING_FOR_DELIVERY':
      return '#F38A3E';
    case 'PENDING_ACCEPTANCE':
      return '#D4B106';
    case 'PENDING_APPROVAL':
      return '#F38A3E';
    case 'APPROVAL_DISAPPROVED':
      return '#00000073';
    case 'ACCEPTED':
      return '#F38A3E';
    case 'CANCELED':
      return '#00000073';
    case 'DECLINED':
      return '#F5222D';
    case 'SENT':
      return '#F38A3E';
    case 'IN_PROGRESS':
      return '#F38A3E';
    case 'PENDING_DELIVERY':
      return '#F38A3E';
    case 'DELIVERING':
      return '#F38A3E';
    case 'DELIVERED':
      return '#43A047';
    case 'DELIVERY_IN_PROGRESS':
      return '#F38A3E';
    default:
      return '#E8EBF2';
  }
};

export const StatusIcon = styled(SVGIcon)<any>`
  width: 26px;
  height: 26px;
  color: ${({ status }) => getStatusColor(status)};
`;
